import type { HelpFile } from '../../types/help'
import { RestrictionRuleRequestsTestIds } from '../../../testids/RestrictionRuleRequestsTestIds'

export const restrictionRuleRequestsHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [RestrictionRuleRequestsTestIds.restrictionRuleRequestsList]:
      'Governance-Anträge zu Restriktionsregel-Lebenszyklus-Änderungen — Anlegen, Ändern, Löschen, Aktivieren und Deaktivieren erfordern stets Genehmigung.',
    [RestrictionRuleRequestsTestIds.btnCreateRequest]: 'Neuen Restriktionsregel-Antrag stellen — um eine neue Regel vorzuschlagen oder eine bestehende zu ändern.',
    [RestrictionRuleRequestsTestIds.colLinkedRule]: 'Restriktionsregel, auf die sich der Antrag bezieht — bei CREATE-Anträgen leer.',
    [RestrictionRuleRequestsTestIds.colRequestType]: 'Art der vorgeschlagenen Änderung — anlegen, aktualisieren, löschen, aktivieren oder deaktivieren.',
    [RestrictionRuleRequestsTestIds.linkRequestName]: 'Antrag öffnen, um vorgeschlagene Änderungen, Kommentare und Genehmigungsstatus einzusehen.',
  },
}
